import React from "react"
import PropTypes from "prop-types"
import { Flex, Typography, Tooltip } from "antd"
import { InfoCircleOutlined } from "@ant-design/icons"
import { useTranslation } from "react-i18next"
import DonutChart from "../../components/DonutChart/DonutChart"
import EmptyState from "components/common/EmptyState"
import styles from "../../style.module.css"

const { Text } = Typography

export default function BookingsByExperienceWidget({ data, description, title }) {
  const { t } = useTranslation()

  const rawLabels = data?.labels ?? []
  const series = Array.isArray(data?.series) ? data.series : []
  const rawValues = series[0]?.data ?? []
  const items = rawLabels.map((name, i) => ({ name, value: rawValues[i] ?? 0 })).filter((item) => item.value > 0)
  const total = items.reduce((sum, item) => sum + item.value, 0)

  return (
    <div className={styles.widgetContent}>
      <Flex justify="space-between" align="center" className={styles.widgetHeader}>
        <Text strong>{title ?? t("ai_dashboard.widget_bookings_by_experience")}</Text>
        {description && (
          <Tooltip title={description} placement="topRight" styles={{ body: { maxWidth: 320 } }}>
            <InfoCircleOutlined className={styles.widgetInfoIcon} />
          </Tooltip>
        )}
      </Flex>
      {items.length === 0
        ? <div className={styles.widgetEmptyState}><EmptyState title={t("ai_dashboard.no_data")} description=" " /></div>
        : (
          <>
            <Text type="secondary" className={styles.textPeriodInfo}>{total} {t("ai_dashboard.booked")} {t("ai_dashboard.during_period")}</Text>
            <DonutChart labels={items.map((item) => item.name)} values={items.map((item) => item.value)} />
          </>
        )
      }
    </div>
  )
}

BookingsByExperienceWidget.propTypes = {
  data: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  description: PropTypes.string,
  title: PropTypes.string,
}
